import VodTestMain from './components/VodTestMain.vue'
import LiveTestMain from './components/LiveTestMain.vue'

export const routes = [
    { path: '', component: VodTestMain },
    { path: '/vod', component: VodTestMain },
    { path: '/live', component: LiveTestMain },
]